import { RouteView } from '@/layouts';

const buyRecordRouter = {
  path: '/buyrecord',
  name: 'Buyrecord',
  redirect: '/buyrecord/purchase-record',
  component: RouteView,
  meta: {
    title: '购买管理',
    icon: 'iconadd-cart',
    roles: ['admin'],
  },
  children: [
    {
      path: 'purchase-record',
      name: 'BuyrecordList',
      component: () => import('@/views/buyRecord/purchaseRecordList'),
      meta: {
        title: '购买记录',
        icon: 'iconorder',
        roles: ['admin'],
      },
    },
    {
      path: 'consume-record',
      name: 'consumeRecordList',
      component: () => import('@/views/buyRecord/consumeRecordList'),
      meta: {
        title: '消费记录',
        icon: 'iconrmb',
        roles: ['admin'],
      },
    },
  ],
};

export default buyRecordRouter;
